/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Casedataintro2Inputs */

const en_casedataintro2 = /** @type {(inputs: Casedataintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Structured facts ClaimPack uses to build your documents. AI fills these in as it reads your evidence — anything you type here overrides what AI extracted.`)
};

const pt_casedataintro2 = /** @type {(inputs: Casedataintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Factos estruturados que o ClaimPack usa para gerar os seus documentos. A IA preenche-os à medida que lê a sua evidência — o que você escrever aqui sobrepõe-se ao que a IA extraiu.`)
};

/**
* | output |
* | --- |
* | "Structured facts ClaimPack uses to build your documents. AI fills these in as it reads your evidence — anything you type here overrides what AI extracted." |
*
* @param {Casedataintro2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const casedataintro2 = /** @type {((inputs?: Casedataintro2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Casedataintro2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_casedataintro2(inputs)
	return pt_casedataintro2(inputs)
});
export { casedataintro2 as "caseDataIntro" }